var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center"},[_c('div',{staticClass:"flyer-thumb-list",attrs:{"tabindex":"0"}},_vm._l((_vm.thumbs),function(flyer){return _c(_vm.blockComponent,{key:flyer.title,tag:"component",attrs:{"flyer-data":flyer}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }